<ds-modal
  [modal]="modal"
  [title]="'label_edit_digital_property' | translate"
  [maxWidthPercentage]="80"
  (modalClosed)="onCancel()"
>
  <div class="modal-content-wrapper">
    @if (digitalAssetFormUpdateEnabled()) {
      <p class="margin-bottom-md" data-test-id="required-fields-label-modal">
        {{ 'required_fields_label' | translate }}
      </p>
    }
    @if (isAdminView) {
      <app-edit-tenant-workspace-digital-property
        [modal]="true"
        [inputDigitalPropertyId]="digitalPropertyId"
        [inputWorkspaceId]="workspaceId"
        [isWebsite]="isWebsite"
        (digitalPropertyEdited)="onDigitalPropertyEdited($event)"
        (cancelled)="onCancel()"
      >
      </app-edit-tenant-workspace-digital-property>
    } @else {
      <app-edit-digital-property
        #editForm
        [workspaceId]="workspaceId"
        [digitalPropertyId]="digitalPropertyId"
        (digitalPropertyEdited)="onDigitalPropertyEdited($event)"
        (cancelled)="onCancel()"
      ></app-edit-digital-property>
      <div class="row mt-4">
        <div class="col-12 d-flex gap-3">
          <button
            ds-button
            form="dp-form-details"
            type="submit"
            [variant]="DsButtonVariants.primary"
            [disabled]="(editForm.saveDisabled$ | async) ?? false"
          >
            {{ 'digital_property_action_update' | translate }}
          </button>
          <button
            ds-button
            form="dp-form-details"
            type="button"
            [variant]="DsButtonVariants.secondary"
            class="margin-right"
            (click)="editForm.onCancel()"
          >
            {{ 'form_cancel' | translate }}
          </button>
        </div>
      </div>
    }
  </div>
</ds-modal>
